
export class CookieHelper {
  cookies;

  constructor() {
    this.cookies = CookieHelper.parseCookies(document.cookie);
  }

  getCookies() {
    return this.cookies;
  }

  checkChanges() {
    const currentCookies = CookieHelper.parseCookies(document.cookie);
    const removed = [...this.cookies.keys()].filter((key) => !currentCookies.has(key));
    const added = [...currentCookies.keys()].filter((key) => !this.cookies.has(key));
    return {added, removed};
  }

  logChanges() {
    try {
      const {removed, added} = this.checkChanges();
      if (removed.length > 0 || added.length > 0) {
        console.log(`cookies updated: removed=[${removed.join(';')}] added=[${added.join(';')}]`);
      }
    } catch (err) {
      console.log('Error checking cookies', err);
    }
  }

  static parseCookies(cookies) {
    try {
      return [...cookies.matchAll(/\s*([-\w]+)=([^; ]+)((\s*;\s*)|$)/g)]
        .filter(([, name]) => name.includes('hoops'))
        .reduce((map, [, name, value]) => map.set(name, value), new Map());
    } catch {
      return new Map();
    }
  }
}
